import { Group } from '@mantine/core';

export const GroupConfig = Group.extend({
  defaultProps: {
    gap: 0,
  },
});
